import { api, unwrap, type components } from '@/shared/api'

export type NotificationSettings = components['schemas']['SettingsResponse']
export type NotificationSettingsBody = components['schemas']['SettingsRequest']
export type PushDevice = components['schemas']['PushSubscriptionResponse']

export const settingsApi = {
  updateProfile: (body: { displayName?: string; timezone?: string }) =>
    unwrap(api.PATCH('/api/v1/me', { body })),
  changePassword: (currentPassword: string, newPassword: string) =>
    unwrap(api.POST('/api/v1/me/password/change', { body: { currentPassword, newPassword } })),

  notificationSettings: () => unwrap(api.GET('/api/v1/me/settings')),
  updateNotificationSettings: (body: NotificationSettingsBody) =>
    unwrap(api.PATCH('/api/v1/me/settings', { body })),

  pushPublicKey: () => unwrap(api.GET('/api/v1/me/push/public-key')),
  pushDevices: () => unwrap(api.GET('/api/v1/me/push-subscriptions')),
  subscribePush: (body: {
    endpoint: string
    keys: { p256dh: string; auth: string }
    deviceLabel?: string | null
  }) => unwrap(api.POST('/api/v1/me/push-subscriptions', { body })),
  unsubscribePush: (id: string) =>
    unwrap(api.DELETE('/api/v1/me/push-subscriptions/{id}', { params: { path: { id } } })),
  testPush: (id: string) =>
    unwrap(api.POST('/api/v1/me/push-subscriptions/{id}/test', { params: { path: { id } } })),

  sessions: () => unwrap(api.GET('/api/v1/me/sessions')),
  endSession: (id: string) =>
    unwrap(api.DELETE('/api/v1/me/sessions/{id}', { params: { path: { id } } })),

  twoFactor: () => unwrap(api.GET('/api/v1/me/2fa')),
  startTwoFactor: (currentPassword: string) =>
    unwrap(api.POST('/api/v1/me/2fa/setup', { body: { currentPassword } })),
  confirmTwoFactor: (code: string) =>
    unwrap(api.POST('/api/v1/me/2fa/confirm', { body: { code } })),
  disableTwoFactor: (currentPassword: string, code: string) =>
    unwrap(api.POST('/api/v1/me/2fa/disable', { body: { currentPassword, code } })),
  regenerateCodes: (currentPassword: string, code: string) =>
    unwrap(api.POST('/api/v1/me/2fa/recovery-codes', { body: { currentPassword, code } })),
}
